import { useMemo } from 'react';

import { Trans } from '@lingui/react/macro';
import { useAtomValue } from 'jotai';

import { selectedPlanAtom } from '../../../atoms';

import { GeneralDisclaimersList } from './GeneralDisclaimersList';

export const LimitationsAndDisclaimersSection = () => {
  // atoms
  const currentPlan = useAtomValue(selectedPlanAtom);

  // Transform Zuub limitations and disclaimers data
  const limitationsData = useMemo(() => {
    if (!currentPlan?.disclaimersAndLimitations) {
      return {
        generalDisclaimers: [],
        categoryLimitations: [],
        footerNote: '',
        isValid: false,
      };
    }

    const generalDisclaimers =
      currentPlan.disclaimersAndLimitations.generalDisclaimers || [];
    const footerNote = currentPlan.disclaimersAndLimitations.footerNote || '';
    const hasData =
      generalDisclaimers.length > 0 ||
      footerNote.length > 0;

    return {
      generalDisclaimers,
      footerNote,
      isValid: hasData,
    };
  }, [currentPlan]);

  // Only show data if we have valid limitations and disclaimers data
  if (!limitationsData.isValid) {
    return (
      <div className="vai-text-center vai-text-gray-500 vai-py-8 vai-bg-gray-50 vai-rounded-lg">
        <Trans>
          No limitations and disclaimers data available for the selected plan.
        </Trans>
      </div>
    );
  }

  return (
    <div className="vai-space-y-6">
      {/* General Disclaimers */}
      <GeneralDisclaimersList
        disclaimers={limitationsData.generalDisclaimers}
      />

      {/* Footer Note */}
      {limitationsData.footerNote && (
        <div className="vai-text-sm vai-text-gray-600 vai-mt-6 vai-pt-4 vai-border-t vai-border-gray-200">
          {limitationsData.footerNote}
        </div>
      )}
    </div>
  );
};
